import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import DateAndTime from '../Steps/DateAndTime'
import Details from '../Steps/Details'
import MediaUpload from '../Steps/MediaUpload'
import Summary from '../Steps/Summary'
import ProgressTimeline from '../../../ProgressTimeline/ProgressTimeline'
import FormHeader from '../FormHeader/FormHeader'
import SummaryBuilding from '../Steps/SummaryBuilding'

const BaseEvent = ({ config, goBack, eventType, handleClose }) => {
  const { t } = useTranslation(['create-event'])
  const [currentStep, setCurrentStep] = useState(0)
  const handleNext = () => {
    setCurrentStep((prev) => prev + 1)
  }
  const handleBack = () => {
    if (!currentStep) {
      return goBack()
    }
    setCurrentStep((prev) => prev - 1)
  }
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Details
            config={config.details}
            onNext={handleNext}
            onBack={handleBack}
            eventType={eventType}
          />
        )
      case 1:
        return (
          <MediaUpload
            config={config.mediaUpload}
            onNext={handleNext}
            onBack={handleBack}
            eventType={eventType}
          />
        )
      case 2:
        return (
          <DateAndTime
            config={config.dateAndTime}
            onNext={handleNext}
            onBack={handleBack}
            eventType={eventType}
          />
        )
      case 3: {
        const SummaryComponent = eventType === 'buildingEvent' ? SummaryBuilding : Summary
        return (
          <SummaryComponent
            config={{ ...config.summary, footer: config.footer }}
            onBack={handleBack}
          />
        )
      }
    }
  }

  const steps = [
    t('create-event:baseEvent.steps.eventDetails'),
    t('create-event:baseEvent.steps.media'),
    t('create-event:baseEvent.steps.dateTime'),
    t('create-event:baseEvent.steps.attendees'),
  ]

  return (
    <React.Fragment>
      <FormHeader eventType={eventType} handleClose={handleClose} />
      <div className="progressbar-wrap">
        <ProgressTimeline currentStep={currentStep} steps={steps} />
      </div>
      {renderStep()}
    </React.Fragment>
  )
}

BaseEvent.propTypes = {
  config: PropTypes.object,
  goBack: PropTypes.func,
  eventType: PropTypes.string,
  handleClose: PropTypes.func,
}

export default BaseEvent
